import lazyLoading from '../../utils/lazyLoading'

export default {
  hidden: false,
  createroutes: true,
  meta: {
    permission: 'ADMV',
    label: 'Leden',
    icon: 'mdi-account',
    expanded: false
  },
  children: [
    {
      name: 'admin_members',
      path: '/admin/members/:member_id?',
      props: true,
      exact: true,
      component: lazyLoading('admin/members/Members'),
      meta: {
        label: 'Leden',
        permission: 'ADMV',
        link: 'admin/members/Members.vue'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/menu/members.js